//Preload

document.addEventListener('DOMContentLoaded', () => {
  const loader = document.getElementById('loader');
  const loaderAfter = document.getElementById('loader-after');
  const loaderContent = document.querySelector('.loader-content');
  const siteContainer = document.querySelector('.site-container');

  const animationDuration = 3000; // длительность анимации в мс (пример)

  setTimeout(() => {
    loaderAfter.classList.remove('is-hidden-loader');
    loaderAfter.classList.add('animate');

    // За 1 секунду до конца анимации добавляем класс is-hidden-loader loader-content
    setTimeout(() => {
      if (loaderContent) {
        loaderContent.classList.add('is-hidden-loader');
      }
    }, animationDuration - 1000);

    // Когда анимация закончится
    loaderAfter.addEventListener('animationend', () => {
      setTimeout(() => {
        loaderAfter.classList.add('is-hidden-loader');
        loader.classList.add('is-hidden-loader');
        if (siteContainer) {
          siteContainer.classList.remove('is-hidden');
        }
      }, 300);
    }, { once: true });
  }, 1000);
});





// Смена темы сайта

const toggleButton = document.getElementById('theme-toggle');
const body = document.body;

toggleButton.addEventListener('click', () => {
  const isLight = body.classList.toggle("light-theme");
});



// Анимация кнопок

const items = document.querySelectorAll('.animate__item');

items.forEach(item => {
  item.addEventListener('mouseenter', () => {
    item.classList.remove('animate-out');
    void item.offsetWidth;
    item.classList.add('animate-in');
  });

  item.addEventListener('mouseleave', () => {
    item.classList.remove('animate-in');
    void item.offsetWidth;
    item.classList.add('animate-out');

    setTimeout(() => {
      item.classList.remove('animate-out');
    }, 800); // Длительность lineRightB
  });
});



// Плавный скролл

document.getElementById('scrollTop').addEventListener('click', () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

document.getElementById('scrollWorks').addEventListener('click', () => {
  document.getElementById('works').scrollIntoView({ behavior: 'smooth' });
});


// Проверка формы

const form = document.querySelector('.feedback__form');
const button = form.querySelector('.feedback__button');

const inputs = form.querySelectorAll('input, textarea');

function checkForm() {
    const isValid = form.checkValidity();

    button.disabled = !isValid;
}

inputs.forEach(input => {
    input.addEventListener('input', checkForm);
});

checkForm();

// Закрытие модалки только по кнопке

document.addEventListener('click', (e) => {
    if (
        e.target.classList.contains('graph-modal') &&
        e.target.classList.contains('is-open')
    ) {
        e.stopImmediatePropagation();
    }
}, true);


const shapes = document.querySelectorAll('.shape');

const random = (min, max) => {
    return Math.random() * (max - min) + min;
};


/*
|--------------------------------------------------------------------------
| Случайное расположение фигур
|--------------------------------------------------------------------------
*/

shapes.forEach((shape) => {

    const x = random(5, 90);
    const y = random(5, 90);

    shape.style.left = `${x}%`;
    shape.style.top = `${y}%`;

});


/*
|--------------------------------------------------------------------------
| Движение за мышью
|--------------------------------------------------------------------------
*/

let mouseX = 0;
let mouseY = 0;

document.addEventListener('mousemove', (event) => {

    mouseX = event.clientX / window.innerWidth - 0.5;
    mouseY = event.clientY / window.innerHeight - 0.5;

    shapes.forEach((shape, index) => {

        /*
         * Каждая следующая фигура
         * двигается немного сильнее
         */

        const speed = 15 + index * 5;

        const x = mouseX * speed;
        const y = mouseY * speed;

        shape.style.setProperty('--mouse-x', `${x}px`);
        shape.style.setProperty('--mouse-y', `${y}px`);

    });

});


/*
|--------------------------------------------------------------------------
| Медленное самостоятельное движение
|--------------------------------------------------------------------------
*/

shapes.forEach((shape) => {

    const duration = random(4, 8);
    const x = random(-20, 20);
    const y = random(-20, 20);

    shape.animate(
        [
            {
                '--float-x': '0px',
                '--float-y': '0px'
            },
            {
                '--float-x': `${x}px`,
                '--float-y': `${y}px`
            },
            {
                '--float-x': '0px',
                '--float-y': '0px'
            }
        ],
        {
            duration: duration * 1000,
            iterations: Infinity,
            easing: 'ease-in-out'
        }
    );

});





const feedbackForm = document.querySelector('.feedback__form');

if (feedbackForm) {
    feedbackForm.addEventListener('submit', async (event) => {
        event.preventDefault();

        const button = feedbackForm.querySelector('.feedback__button');
        const buttonText = button.querySelector('.btn__red_text');
        const status = feedbackForm.querySelector('.feedback__status');

        const formData = new FormData(feedbackForm);

        button.disabled = true;
        buttonText.textContent = 'Sending...';

        status.textContent = '';
        status.className = 'feedback__status';

        try {
            const response = await fetch(feedbackForm.action, {
                method: 'POST',
                body: formData
            });

            const result = await response.text();

            if (response.ok && result.trim() === 'success') {

                status.textContent = '✓ Message sent successfully';
                status.classList.add('feedback__status--success');

                feedbackForm.reset();

            } else {

                throw new Error('Sending error');

            }

        } catch (error) {

            status.textContent = '✕ Something went wrong. Please try again.';
            status.classList.add('feedback__status--error');

        } finally {

            button.disabled = false;
            buttonText.textContent = 'Send Message';

        }
    });
}
